module.exports = __webpack_public_path__ + "img/study.3e467e09.png";